import { useCallback, useRef, useState } from 'react';
import { useMeasure, useScroll } from 'react-use';

import { useIsDesktop } from './useBreakpoints';

export const useHorizontalTabbedScroll = (items, tag = 'li') => {
    const isDesktop = useIsDesktop();
    const list = useRef(null);
    const [index, setIndex] = useState(0);
    const [root, { width }] = useMeasure();
    const { x: listScrollX } = useScroll(list);

    const listScrollWidth = (list.current && list.current.scrollWidth) || width;
    const hasScroll = isDesktop && listScrollWidth > width;
    const hasLeftBtn = hasScroll && listScrollX > 0;
    const hasRightBtn = hasScroll && listScrollX + width < listScrollWidth - 1;

    const moveTo = useCallback(
        (targetIndex) => {
            if (targetIndex < 0 || targetIndex > items - 1) {
                return;
            }

            const parentWidth = list.current.parentElement.clientWidth;
            const nodes = Array.from(list.current.querySelectorAll(tag));
            let scrollPosition = 0;

            for (let i = 0; i < targetIndex; i++) {
                scrollPosition += nodes[i].clientWidth + 8;
            }

            list.current.scrollLeft = scrollPosition - (parentWidth - 32) / 2 + nodes[targetIndex].clientWidth / 2 - 4;
            setIndex(targetIndex);
        },
        [items, index, listScrollWidth]
    );
    const moveLeft = useCallback(() => moveTo(index - 1), [moveTo]);
    const moveRight = useCallback(() => moveTo(index + 1), [moveTo]);

    return { root, hasLeftBtn, moveLeft, list, hasRightBtn, moveRight, moveTo, currentIndex: index };
};
